import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'alvo_cookie_consent';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(CONSENT_KEY);
    } catch {
      return false;
    }
  });
  const navigate = useNavigate();

  const decide = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    localStorage.setItem(`${CONSENT_KEY}_at`, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6 animate-cookie-in"
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto rounded-2xl border border-white/10 bg-[#111827]/95 backdrop-blur-xl shadow-2xl">
        <div className="p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <div className="flex items-start gap-3 min-w-0 flex-1">
            <div className="shrink-0 w-10 h-10 rounded-full bg-[#22C55E]/15 flex items-center justify-center">
              <Cookie className="w-5 h-5 text-[#22C55E]" />
            </div>
            <div className="min-w-0">
              <p className="text-sm sm:text-base text-white font-semibold">Nós usamos cookies</p>
              <p className="mt-1 text-sm text-zinc-400 break-words">
                Utilizamos cookies para manter sua sessão e melhorar sua experiência no ALVO. Você pode aceitar
                ou recusar os cookies não essenciais. Saiba mais na nossa{' '}
                <button
                  onClick={() => navigate('/privacidade')}
                  className="text-[#22C55E] hover:text-[#16a34a] underline underline-offset-2 transition-colors"
                  data-testid="cookie-privacy-link"
                >
                  Política de Privacidade
                </button>
                .
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={() => decide('rejected')}
              className="flex-1 md:flex-none px-5 py-2.5 rounded-full text-sm font-semibold text-zinc-300 border border-white/15 hover:bg-white/5 hover:text-white transition-colors"
              data-testid="cookie-reject-btn"
            >
              Recusar
            </button>
            <button
              onClick={() => decide('accepted')}
              className="flex-1 md:flex-none px-6 py-2.5 rounded-full text-sm font-semibold text-black bg-[#22C55E] hover:bg-[#16a34a] transition-colors"
              data-testid="cookie-accept-btn"
            >
              Aceitar
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes cookie-in {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-cookie-in { animation: cookie-in 0.4s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default CookieBanner;
